import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseButton } from './PurchaseButton';
import { Scissors, Search, MessageSquareQuote, Sparkles, Wind, Sunrise } from 'lucide-react';
export function CierreMethodSection() {
  const letters = [{
    l: 'C',
    icon: <Scissors size={20} data-id="element-88" />,
    title: 'Corta la conexión invisible',
    desc: 'Rituales para desenganchar tu energía de la suya.'
  }, {
    l: 'I',
    icon: <Search size={20} data-id="element-89" />,
    title: 'Identifica lo que todavía te ata',
    desc: 'Descubre las lealtades ocultas que te impiden avanzar.'
  }, {
    l: 'E',
    icon: <MessageSquareQuote size={20} data-id="element-90" />,
    title: 'Expresa lo que no pudiste decir',
    desc: 'Canaliza las palabras no dichas sin necesidad de contactarle.'
  }, {
    l: 'R',
    icon: <Sparkles size={20} data-id="element-91" />,
    title: 'Recupera tu energía',
    desc: 'Llama de vuelta los fragmentos de ti que dejaste en esa historia.'
  }, {
    l: 'R',
    icon: <Wind size={20} data-id="element-92" />,
    title: 'Reordena tu espacio emocional',
    desc: 'Limpia tu entorno físico y digital de huellas emocionales.'
  }, {
    l: 'E',
    icon: <Sunrise size={20} data-id="element-93" />,
    title: 'Encárnate en tu nueva versión',
    desc: 'Ancla tu identidad presente, libre de la espera.'
  }];
  return <section className="py-24 md:py-28 px-4 bg-primary relative text-cream overflow-hidden" data-id="element-94">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-95"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-soft/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-96"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-97">
        <div className="text-center mb-16" data-id="element-98">
          <span className="font-sans text-gold text-xs font-bold tracking-[0.3em] uppercase mb-4 inline-block px-4 py-1.5 border border-gold/30 rounded-full" data-id="element-99">
            ✦ El Mecanismo Único ✦
          </span>
          <h2 className="font-serif font-bold text-4xl md:text-6xl mb-6 mt-6" data-id="element-100">
            MÉTODO <span className="text-gold" data-id="element-101">C.I.E.R.R.E.</span>™
          </h2>
          <p className="font-sans text-cream/80 text-base md:text-lg max-w-2xl mx-auto" data-id="element-102">
            Un proceso guiado basado en{' '}
            <span className="font-bold text-gold" data-id="element-103">psicología simbólica</span>,
            actos de cierre y reconstrucción personal.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-5 mb-16" data-id="element-104">
          {letters.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white/8 backdrop-blur-sm border border-gold/20 rounded-2xl p-5 md:p-6 flex items-start gap-4 hover:bg-white/12 hover:border-gold/40 transition-all hover:-translate-y-1" data-id="element-105">
              <div className="font-serif font-bold text-5xl text-gold shrink-0 leading-none w-14" data-id="element-106">
                {item.l}
              </div>
              <div className="flex-1" data-id="element-107">
                <div className="flex items-center gap-2 mb-1" data-id="element-108">
                  <span className="text-gold/70" data-id="element-109">{item.icon}</span>
                  <h3 className="font-sans font-bold text-base md:text-lg text-white" data-id="element-110">
                    {item.title}
                  </h3>
                </div>
                <p className="font-sans text-sm text-cream/70 leading-relaxed" data-id="element-111">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-112">
          <PurchaseButton text="QUIERO ACCESO INMEDIATO" variant="dark" className="max-w-md" data-id="element-113" />
        </div>
      </div>
    </section>;
}